const CREATE = "CREATE";
const EDIT = "EDIT";

export const Modes = {
    CREATE,
    EDIT,
};
